import { VendorRebateCategoryPrograms } from '../../../components/Vendor/RebateCategories';

export function RebateCategoryPrograms() {
  return <VendorRebateCategoryPrograms />;
}
